require('@atlaskit/css-reset/bundle.css');
require('@atlaskit/reduced-ui-pack');

import React from 'react';
import ReactDOM from 'react-dom';

import { ErrorApp } from './ErrorApp.tsx';

/**
 * Please note this package is pre-compiled so you are required to
 * run `yarn build` and check-in the generated files in `prebuild` folder.
 */

/**
 * DO NOT ADD ANY ADDITIONAL LOGIC IN THIS FILE.
 * THIS FILE IS NOT ALWAYS LOADED WITH THE ERROR APP.
 *
 * If you need to add any logic to the error app, add it in the `ErrorApp` component or one of its children
 *
 * The Error App can either be rendered by EITHER:
 * 1. loading the prebuilt HTML, which requires this JS file (cc-proxy does this), or
 * 2. directly rendering the (loadable) <ErrorApp> component, which circumvents this JS file (the main
 * CFE SPA does this in `confluence-frontend-server/src/index.js`)
 */
// eslint-disable-next-line react/no-deprecated
ReactDOM.render(
	<ErrorApp entryPoint="standaloneErrorApp" />,
	// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
	document.getElementById('confluence-ui'),
);
